import type { Story } from '@/store/story-types'

export const FITNESS_GYM_NEW3_STORY: Story = {
  id: 'fitness-gym-new3',
  name: 'FitZone — Fitness & Wellness',
  narrative: 'A modern fitness and wellness platform with classes, gear, and memberships. Users browse fitness classes, shop workout gear, and sign up for membership plans.',
  goals: ['Browse fitness classes and schedules', 'Shop workout gear and accessories', 'View membership plans and pricing', 'Add gear to cart and checkout'],
  lifecycle: 'ready',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'completed', elementCount: 7, linkedPageId: 'home', description: 'Landing page with classes, gear catalog, and membership plans' },
    { id: 'pg-detail', title: 'Product Detail', order: 1, status: 'completed', elementCount: 5, linkedPageId: 'product-detail', description: 'Product detail with specifications and add-to-cart' },
    { id: 'pg-cart', title: 'Cart', order: 2, status: 'completed', elementCount: 4, linkedPageId: 'cart', description: 'Shopping cart with items and total' },
    { id: 'pg-checkout', title: 'Checkout', order: 3, status: 'completed', elementCount: 4, linkedPageId: 'checkout', description: 'Checkout with shipping and payment' },
  ],
  bddScenarios: [
    {
      id: 'bdd-1', name: 'Browse Fitness Products',
      description: 'User browses workout gear and classes',
      steps: [
        { type: 'given', text: 'the user opens the fitness app' },
        { type: 'when', text: 'the home page loads' },
        { type: 'then', text: 'classes, gear cards, and membership plans are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2', name: 'View Gear Detail',
      description: 'User views details of a workout product',
      steps: [
        { type: 'given', text: 'the user is browsing gear', linkedPageId: 'home' },
        { type: 'when', text: 'they tap a product card' },
        { type: 'then', text: 'the product detail with specs and price is shown', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3', name: 'Add Gear to Cart',
      description: 'User adds workout gear to cart',
      steps: [
        { type: 'given', text: 'the user is on product detail', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they tap Add to Cart' },
        { type: 'then', text: 'the item is added and cart updates', linkedFlowId: 'addToCart' },
      ],
    },
    {
      id: 'bdd-4', name: 'Complete Purchase',
      description: 'User completes the purchase',
      steps: [
        { type: 'given', text: 'the user has items in cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they proceed to checkout and submit' },
        { type: 'then', text: 'order is confirmed and cart is cleared', linkedPageId: 'checkout' },
      ],
    },
  ],
}
